export default __webpack_public_path__ + "assets/models/fb28c54a6d1a28f06de3c38a5c6d728c.glb";